import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { CarregandoService } from 'src/app/services/carregando.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { ProdutoLoteService } from 'src/app/services/produto-lote.service';

@Component({
  selector: 'app-importar-lotes-modal',
  templateUrl: './importar-lotes-modal.component.html',
  styleUrls: ['./importar-lotes-modal.component.scss']
})
export class ImportarLotesModalComponent implements OnInit {
  selectedFile: File;

  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    public dialogRef: MatDialogRef<ImportarLotesModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private notificacaoService: NotificacaoService,
    private carregandoService: CarregandoService,
    private produtoLoteService: ProdutoLoteService
  ) { }

  ngOnInit() { }

  importar(): void {
    if (!this.selectedFile) {
      return;
    }

    this.carregandoService.mostra("importarLotes");

    const dados = new FormData();

    dados.append('arquivo', this.selectedFile);

    this.produtoLoteService.importar(dados)
      .subscribe(
        () => {
          this.carregandoService.esconde('importarLotes');
          this.notificacaoService.sucesso('Você será notificado quando a importação estiver concluída.');
          this.dialogRef.close(true);
        },
        (erro) => {
          this.carregandoService.esconde('importarLotes');
          this.notificacaoService.erro(erro);
        }
      );
  }

  fechar() {
    this.dialogRef.close();
  }

  onFileChanged(event) {
    this.selectedFile = event.target.files[0];
  }

  excluirArquivo() {
    this.selectedFile = undefined;
  }
}
